.header {
  margin: 0 0 8px 0;
  padding: 4px 0 8px 0;
  border-bottom: 1px solid var(--tuna-palette-divider);
}

.headerSpaces {
  margin-top: 0;
}

.sectionCaption {
  display: block;
  margin-top: -4px;
  margin-bottom: 12px;
  color: var(--tuna-palette-text-secondary);
}

.spacesWrapper {
  position: relative;
}

.addButton {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 8px;
}

.spacer {
  flex: 1;
}

.fabContainer {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 1050;
}

@media (max-width: 899.95px) {
  .fabContainer {
    bottom: 72px;
  }
}
